import React, { useEffect } from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { t } from 'Locale/index';
import { RECORDINGS_TYPE } from '../../../options';
import AllRecordings from './AllRecordings';
import { IconBack, iconPlaceholder } from '../../Navigation/navigationHeaderIcons';
import { navigationStyles } from '../../Navigation/navigationOptions';
import NavigationService from '../../Navigation/navigationService';
import { getMaterialTopBarOptions } from '../../Navigation/navigationUtils';

const Tab = createMaterialTopTabNavigator();

const tabs = () => [
    <Tab.Screen
        name={t('RECORDINGS.MY_RECORDINGS').toUpperCase()}
        component={AllRecordings}
        key="myRecordingsTab"
        options={() => {
            const tabBarLabel =
                NavigationService.globalParams.myRecordingsLabel || t('RECORDINGS.MY_RECORDINGS');
            return {
                tabBarLabel,
                headerLeft: () => IconBack,
                headerRight: () => iconPlaceholder,
                headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight
            };
        }}
        initialParams={{ recordingsType: RECORDINGS_TYPE.MY_RECORDINGS }}
    />,
    <Tab.Screen
        name={t('RECORDINGS.PLANNED_RECORDINGS').toUpperCase()}
        component={AllRecordings}
        key="plannedRecordingsTab"
        options={() => {
            const tabBarLabel =
                NavigationService.globalParams.plannedRecordingsLabel ||
                t('RECORDINGS.PLANNED_RECORDINGS');
            return {
                tabBarLabel,
                headerLeft: () => IconBack,
                headerRight: () => iconPlaceholder,
                headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight
            };
        }}
        initialParams={{ recordingsType: RECORDINGS_TYPE.PLANNED_RECORDINGS }}
    />
];

const iptvTabs = () => [
    ...tabs(),
    <Tab.Screen
        name={t('RECORDINGS.IPTV_RECORDINGS').toUpperCase()}
        component={AllRecordings}
        key="iptvRecordingsTab"
        options={() => {
            const tabBarLabel =
                NavigationService.globalParams.iptvRecordingsLabel ||
                t('RECORDINGS.IPTV_RECORDINGS');
            return {
                tabBarLabel,
                headerLeft: () => IconBack,
                headerRight: () => iconPlaceholder,
                headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight
            };
        }}
        initialParams={{ recordingsType: RECORDINGS_TYPE.IPTV_RECORDINGS }}
    />
];

export const TabsNavigator = () => {
    const navigatorOptions = getMaterialTopBarOptions(tabs().length, true);
    return <Tab.Navigator {...navigatorOptions}>{tabs()}</Tab.Navigator>;
};

export const TabsNavigatorWithIPTV = () => {
    const navigatorOptions = getMaterialTopBarOptions(iptvTabs().length, true);
    return <Tab.Navigator {...navigatorOptions}>{iptvTabs()}</Tab.Navigator>;
};
